import apiRequest from '../api/request';

/**
 * Signs the current user in to Interval Targets and opens it in a new tab.
 *
 * The backend returns the whole sign-in link — where Targets is served comes
 * from its INCENTIVE_TRACKER_URL, so this portal needs no setting of its own.
 * Targets redeems the five-minute, single-use token in that link for a real
 * portal session and strips it from the URL. The employee id comes from the
 * session on the backend, never from anything sent here.
 */
export async function openIntervalTargets(onError) {
  // Opened synchronously, before any await. Browsers only allow window.open
  // while a user gesture is still in scope; requesting the link first and
  // opening afterwards loses that scope and the tab gets blocked.
  const tab = window.open('', '_blank');

  if (!tab) {
    onError('Your browser blocked the new tab. Allow pop-ups for this site and try again.');
    return;
  }

  try {
    const res = await apiRequest({ method: 'post', url: 'interval-targets/open' });

    if (res?.status !== 'success' || !res?.data?.url) {
      tab.close();
      onError(res?.message || 'Could not open Interval Targets.');
      return;
    }

    tab.location = res.data.url;
  } catch (error) {
    tab.close();
    onError('Could not reach Interval Targets. Please try again.');
  }
}
